import { Property } from "@app/models/Property";
import { PropertyGroup } from "@app/models/PropertyGroup";
import { CouponData } from "@app/models/CouponData";
import { PropertyGroupCreateInfo } from "@app/models/PropertyGroupCreateInfo";
import { PropertyGroupMemberUpdateInfo } from "@app/models/PropertyGroupMemberUpdateInfo";
import { PropertyGroupUpdateInfo } from "@app/models/PropertyGroupUpdateInfo";
import { HOA } from "@app/models/HOA";
import { Confirmation } from "@app/models/Confirmation";
import { PropertyGroupCandidate } from "@app/models/PropertyGroupCandidate";
import { Injectable } from "@angular/core";
import { HOAApiBase } from "@app/services/apiServices/utils/HOAApiBase";
import { Observable } from "rxjs";
import { HttpResponse } from "@angular/common/http";

@Injectable({ providedIn: "root" })
export class PropertyGroupApi extends HOAApiBase {

    constructor() {
        super('PropertyGroupApi');
    }

    public propertyGroupIdGet(id: number): Observable<Property> {
        if (!id || id <= 0) {
            throw new Error('Missing or invalid parameter id when calling propertyGroupIdGet');
        }

        return this.http.get<Property>(this.createUrl(this.getBasePath(), `/property-groups/${id}`))
    }

    public propertyGroupRename(propertyGroupId: number, propertyGroupNickname: string): Observable<PropertyGroup> {
        if (!propertyGroupId || propertyGroupId <= 0) {
            throw new Error('Missing or invalid parameter propertyGroupId when calling propertyGroupRename');
        }
        if (!propertyGroupNickname || propertyGroupNickname.length ===0) {
            throw new Error('Missing or invalid parameter propertyGroupUpdateInfo when calling propertyGroupRename');
        }

        const localVarPath = this.createUrl(this.getBasePath(), `/property-groups/${propertyGroupId}/update`);

        const propertyGroupUpdateInfo: PropertyGroupUpdateInfo = {
            propertyGroupId: propertyGroupId,
            propertyGroupNickname: propertyGroupNickname
        }

        return this.http.post<PropertyGroup>(localVarPath, propertyGroupUpdateInfo)

    }

    public getAvailableGroups(id: number, partyId: number): Observable<PropertyGroup[]> {
        if (!id || id <= 0) {
            throw new Error('Missing or invalid parameter id when calling getAvailableGroups');
        }
        if (!partyId || partyId <= 0) {
            throw new Error('Missing or invalid parameter partyId when calling getAvailableGroups');
        }

        const localVarPath = this.createUrl(this.getBasePath(), "/property-groups/" + id + "/available-groups");

        return this.http.get<PropertyGroup[]>(localVarPath, {
            params: {
                partyId: partyId
            }
        })
    }

    public getPropertyGroupMembers(propertyGroupId: number): Observable<Property[]> {
        if (!propertyGroupId || propertyGroupId <= 0) {
            throw new Error('Missing or invalid parameter propertyGroupId when calling getPropertyGroupMembers');
        }
        const localVarPath = this.createUrl(this.getBasePath(), "/property-groups/" + propertyGroupId + "/properties");

        return this.http.get<Property[]>(localVarPath);
    }

    public getPropertyGroupCandidates(id: number, partyId: number): Observable<PropertyGroupCandidate[]> {
        if (!id || id <= 0) {
            throw new Error('Missing or invalid parameter id when calling getPropertyGroupCandidates');
        }
        if (!partyId || partyId <= 0) {
            throw new Error('Missing or invalid parameter partyId when calling getPropertyGroupCandidates');
        }

        const localVarPath = this.createUrl(this.getBasePath(), "/property-groups/" + id + "/group-candidates");

        return this.http.get<PropertyGroupCandidate[]>(localVarPath, {
            params: {
                partyId: partyId
            }
        });
    }

    public createPropertyGroup(nickName: string, propertyIds: number[]): Observable<HttpResponse<PropertyGroup>> {
        if (!nickName || nickName.length === 0) {
            throw new Error('Missing or invalid parameter nickName when calling createPropertyGroup');
        }
        if (!propertyIds || propertyIds.length < 2) {
            throw new Error('Missing or invalid parameter propertyIds when calling createPropertyGroup');
        }

        const createInfo: PropertyGroupCreateInfo = {
            propertyGroupNickname: nickName,
            propertyIds: propertyIds
        }

        const localVarPath = this.createUrl(this.getBasePath(), "/property-groups");

        return this.http.post<PropertyGroup>(localVarPath, createInfo, { observe: "response" });
    }

    public propertyGroupAddProperties(propertyGroupId: number, propertyIds: number[]): Observable<PropertyGroup> {
        if (!propertyGroupId || propertyGroupId <= 0) {
            throw new Error('Missing or invalid parameter propertyGroupId when calling propertyGroupAddProperties');
        }
        if (!propertyIds || propertyIds.length < 1) {
            throw new Error('Missing or invalid parameter propertyIds when calling propertyGroupAddProperties');
        }

        const updateInfo: PropertyGroupMemberUpdateInfo = {
            propertyGroupId: propertyGroupId,
            propertyIds: propertyIds
        }

        const localVarPath = this.createUrl(this.getBasePath(), "/property-groups/" + propertyGroupId + "/properties");

        return this.http.post<PropertyGroup>(localVarPath, updateInfo);
    }

    public propertyGroupRemoveProperties(propertyGroupId: number, propertyId: number): Observable<HttpResponse<Confirmation>> {
        if (!propertyGroupId || propertyGroupId <= 0) {
            throw new Error('Missing or invalid parameter propertyGroupId when calling propertyGroupRemoveProperties');
        }
        if (!propertyId || propertyId <= 0) {
            throw new Error('Missing or invalid parameter propertyId when calling propertyGroupRemoveProperties');
        }

        const localVarPath = this.createUrl(this.getBasePath(), "/property-groups/" + propertyGroupId + "/properties");

        return this.http.delete<Confirmation>(localVarPath, {
            params: {
                propertyIds: propertyId
            },
            observe: 'response'
        })

    }

    public getHoa(couponData: CouponData): Observable<HttpResponse<HOA>> {
        if(!couponData
                || !couponData.pmcCouponId || couponData.pmcCouponId.length === 0
                || !couponData.hoaCouponId || couponData.hoaCouponId.length === 0) {
            throw new Error('Missing or invalid parameter couponData when calling getHoa');
        }

        const localVarPath = this.createUrl(this.getBasePath(), '/organization/hoa');

        return this.http.get<HOA>(localVarPath, {
            params: {
                pmcCouponId: couponData.pmcCouponId,
                hoaCoupondId: couponData.hoaCouponId
            },
            observe: 'response'
        })
    }

}


